import { Box } from "@mui/material";
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import SquareFootIcon from '@mui/icons-material/SquareFoot';

const enabledIconColor = '#FC581F'
const disabledIconColor = '#A1A1A1'

export const characteristicCategoryIcons = [
    { label: "Altera precio y dimensiones", value: "price_and_dimensions", iconComponent: (
        <Box
            sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 1,
            }}
        >
            <AttachMoneyIcon sx={{ fontSize: {lg:'1.5rem'}, color: enabledIconColor}}/>
            <SquareFootIcon sx={{ fontSize: {lg:'1.5rem'}, color: enabledIconColor}} />
        </Box>
    ) },
    { label: "Solo altera precio", value: "price_only", iconComponent: (
        <Box
            sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 1,
            }}
        >
            <AttachMoneyIcon sx={{ fontSize: {lg:'1.5rem'}, color: enabledIconColor}}/>
            <SquareFootIcon sx={{ fontSize: {lg:'1.5rem'}, color: disabledIconColor}} />
        </Box>
    )},
    { label: "Solo altera dimensiones", value: "dimensions_only", iconComponent: (
        <Box
            sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 1,
            }}
        >
            <AttachMoneyIcon sx={{ fontSize: {lg:'1.5rem'}, color: disabledIconColor}}/>
            <SquareFootIcon sx={{ fontSize: {lg:'1.5rem'}, color: enabledIconColor}} />
        </Box>
    )},
    { label: "No altera precio ni dimensiones", value: "none", iconComponent: (
        <Box
            sx={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 1,
            }}
        >
            <AttachMoneyIcon sx={{ fontSize: {lg:'1.5rem'}, color: disabledIconColor}}/>
            <SquareFootIcon sx={{ fontSize: {lg:'1.5rem'}, color: disabledIconColor}} />
        </Box>
    ) }
]